import React, { useState, useEffect } from 'react';
import { TYPES, TYPE_COLORS } from '../data/types';
import './Results.css';

const COMPAT = {
  INTJ:['ENFP','ENTP'], INTP:['ENTJ','ENFJ'], ENTJ:['INTP','INFP'], ENTP:['INTJ','INFJ'],
  INFJ:['ENTP','ENFP'], INFP:['ENTJ','ENFJ'], ENFJ:['INTP','ISFP'], ENFP:['INTJ','INFJ'],
  ISTJ:['ESFP','ESTP'], ISFJ:['ESFP','ESTP'], ESTJ:['ISFP','ISTP'], ESFJ:['ISFP','ISTP'],
  ISTP:['ESFJ','ESTJ'], ISFP:['ENFJ','ESFJ'], ESTP:['ISFJ','ISTJ'], ESFP:['ISFJ','ISTJ'],
};

const CAREERS = {
  INTJ:[{icon:'💻',title:'Technologie & IT',desc:'Software-Architektur, KI, Systemdesign'},{icon:'📊',title:'Strategie',desc:'Unternehmensberatung, Strategieentwicklung'},{icon:'🔬',title:'Wissenschaft',desc:'Grundlagenforschung, Analytik'}],
  ENFP:[{icon:'🎨',title:'Kreativwirtschaft',desc:'Marketing, Design, Content'},{icon:'🧑‍🏫',title:'Bildung & Coaching',desc:'Training, Mentoring'},{icon:'🌍',title:'NGO & Soziales',desc:'Non-profit, Community'}],
};

function getCareers(type) {
  return CAREERS[type] || [
    {icon:'💼',title:'Management',desc:'Führung, Organisation, Planung'},
    {icon:'🤝',title:'Beratung',desc:'Kundenbeziehungen, Consulting'},
    {icon:'🎯',title:'Projektmanagement',desc:'Koordination, Zielorientierung'},
  ];
}

export default function Results({ result, email }) {
  const [tab, setTab] = useState('overview');
  const [emailSent, setEmailSent] = useState(false);
  const data = TYPES[result] || TYPES['INFP'];
  const colors = TYPE_COLORS[result] || TYPE_COLORS['INFP'];
  const compat = COMPAT[result] || ['ENFP','INTJ'];

  useEffect(() => {
    window.scrollTo(0, 0);
    setEmailSent(true); // will be set by backend
  }, []);

  const dims = [
    { left:`Extrovertiert (E)`, right:`Introvertiert (I)`, val: result[0]==='E' ? 72 : 28 },
    { left:`Wahrnehmend (S)`,   right:`Intuitiv (N)`,      val: result[1]==='S' ? 65 : 35 },
    { left:`Denkend (T)`,       right:`Fühlend (F)`,       val: result[2]==='T' ? 70 : 30 },
    { left:`Urteilend (J)`,     right:`Wahrnehmend (P)`,   val: result[3]==='J' ? 68 : 32 },
  ];

  const TABS = ['overview','strengths','relationships','career'];
  const TAB_LABELS = { overview:'Übersicht', strengths:'Stärken & Schwächen', relationships:'Beziehungen', career:'Karriere' };

  return (
    <div className="results-page">
      <nav className="results-nav">
        <span className="logo-text" style={{fontFamily:'Nunito,sans-serif',fontSize:20,fontWeight:900,letterSpacing:'-0.03em'}}>
          <span style={{color:'var(--teal)'}}>ICH</span><span style={{color:'var(--text)'}}>TYPE</span><span style={{fontSize:11,fontWeight:700,color:'var(--text3)',marginLeft:1}}>.DE</span>
        </span>
        <button className="share-btn" onClick={() => {
          const text = `Ich bin ${result} – ${data.name}! Mach den kostenlosen Test: ichtype.de`;
          navigator.share ? navigator.share({text, url:'https://ichtype.de'}) : navigator.clipboard.writeText(text).then(()=>alert('Link kopiert!'));
        }}>
          📤 Ergebnis teilen
        </button>
      </nav>

      {/* HEADER */}
      <div className="result-header" style={{background:`linear-gradient(160deg, ${colors.bg} 0%, #ffffff 100%)`}}>
        <div className="result-header-inner">
          <div className="rarity-badge" style={{background:colors.bg, borderColor:colors.border, color:colors.accent}}>
            ✦ {data.rarity} · Nur {data.percent} der Bevölkerung
          </div>
          <div className="result-emoji-big">{data.emoji}</div>
          <div className="result-code-big" style={{color:colors.accent}}>{data.code}</div>
          <div className="result-name-big">{data.name}</div>
          <div className="result-tagline">{data.tagline}</div>
        </div>
      </div>

      {/* TABS */}
      <div className="tabs-wrap">
        <div className="tabs">
          {TABS.map(t => (
            <button key={t} className={`tab ${tab===t?'active':''}`} onClick={()=>setTab(t)}>
              {TAB_LABELS[t]}
            </button>
          ))}
        </div>
      </div>

      <div className="result-body">

        {/* EMAIL SENT NOTICE */}
        {email && (
          <div className="email-sent">
            ✉️ Dein vollständiger Bericht wurde an <strong>{email}</strong> gesendet!
          </div>
        )}

        {tab === 'overview' && (
          <div className="tab-panel">
            <div className="r-section">
              <h2 className="r-title">Dein Profil</h2>
              <p className="r-text">{data.description}</p>
            </div>

            <div className="r-section">
              <h2 className="r-title">Deine vier Dimensionen</h2>
              <div className="dims">
                {dims.map((d,i) => (
                  <div key={i} className="dim-row">
                    <div className="dim-left" style={{color: d.val>50 ? colors.accent : 'var(--text4)'}}>{d.left}</div>
                    <div className="dim-track"><div className="dim-fill" style={{width:`${d.val}%`}} /></div>
                    <div className="dim-right" style={{color: d.val<50 ? colors.accent : 'var(--text4)'}}>{d.right}</div>
                  </div>
                ))}
              </div>
            </div>

            <div className="r-section">
              <h2 className="r-title">Bekannte {data.code}s</h2>
              <div className="famous-chips">
                {data.famous.map(f => <div key={f} className="famous-chip">⭐ {f}</div>)}
              </div>
            </div>
          </div>
        )}

        {tab === 'strengths' && (
          <div className="tab-panel">
            <div className="r-section">
              <h2 className="r-title">✅ Deine Stärken</h2>
              <div className="traits-grid">
                {data.strengths.map(s => <div key={s} className="trait trait-s">✓ {s}</div>)}
              </div>
            </div>
            <div className="r-section">
              <h2 className="r-title">⚠️ Deine Herausforderungen</h2>
              <div className="traits-grid">
                {data.challenges.map(c => <div key={c} className="trait trait-c">△ {c}</div>)}
              </div>
            </div>
          </div>
        )}

        {tab === 'relationships' && (
          <div className="tab-panel">
            <div className="r-section">
              <h2 className="r-title">💞 Kompatible Typen</h2>
              <p className="r-text" style={{marginBottom:24}}>Diese Typen ergänzen dich besonders gut — in Freundschaft und Liebe.</p>
              <div className="compat-grid">
                {compat.map(t => {
                  const cd = TYPES[t]; const cc = TYPE_COLORS[t];
                  return (
                    <div key={t} className="compat-card" style={{borderColor:cc.border}}>
                      <div className="compat-emoji">{cd.emoji}</div>
                      <div className="compat-code" style={{color:cc.accent}}>{t}</div>
                      <div className="compat-name">{cd.name}</div>
                      <div className="compat-tag">{cd.tagline}</div>
                    </div>
                  );
                })}
              </div>
            </div>
            <div className="r-section">
              <h2 className="r-title">Du in Beziehungen</h2>
              <p className="r-text">Als {data.code} bringst du {data.strengths[0].toLowerCase()} und {data.strengths[1].toLowerCase()} in deine Beziehungen ein. Du suchst nach echter Verbindung. Deine größte Herausforderung ist dabei {data.challenges[0].toLowerCase()}.</p>
            </div>
          </div>
        )}

        {tab === 'career' && (
          <div className="tab-panel">
            <div className="r-section">
              <h2 className="r-title">💼 Deine idealen Berufsfelder</h2>
              <div className="career-grid">
                {getCareers(result).map(c => (
                  <div key={c.title} className="career-card">
                    <div className="career-icon">{c.icon}</div>
                    <div className="career-title">{c.title}</div>
                    <div className="career-desc">{c.desc}</div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        )}

        <div className="share-box">
          <h3>War dein Ergebnis überraschend?</h3>
          <p>Teile deinen Typ — und lass Freunde herausfinden, wer sie wirklich sind.</p>
          <button className="btn-share" onClick={() => {
            const text = `Ich bin ${result} – ${data.name}! Finde deinen Typ: ichtype.de`;
            navigator.share ? navigator.share({text, url:'https://ichtype.de'}) : navigator.clipboard.writeText(text).then(()=>alert('Kopiert!'));
          }}>
            📤 Ergebnis teilen
          </button>
        </div>
      </div>
    </div>
  );
}
